import TICKETSET_LIST from '../../graphql/ticketset/list.graphql'
import TICKETSET_LIST_FULL from '../../graphql/ticketset/listFull.graphql'
import TICKETSET_UPDATE from '../../graphql/ticketset/update.graphql'

import {processMutation, processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        list: [],
    },

    mutations: {
        ...genericMutations('list'),

        setListFull(state, data) {
            data.forEach((mod) => {
                state.list.forEach((item, index) => {
                    if (parseInt(mod.id) === parseInt(item.id)) {
                        state.list[index] = mod
                    }
                })
            })
            state.list = [...state.list]
        },
    },

    actions: {
        async list({commit}) {
            return await processQuery(this, TICKETSET_LIST, 'ticketset.list', {}, 'ticketset/setList')
        },
        async listFull({commit}, ids) {
            return await processQuery(this, TICKETSET_LIST_FULL, 'ticketset.list', { ids: ids }, 'ticketset/setListFull')
        },
        async update({commit}, data) {
            return await processMutation(this, TICKETSET_UPDATE, 'ticketset.update', data)
        }
    }
}